import React, { useEffect } from "react";

import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import Footer from "../../containers/Footer/Footer";
import TermsConditions from "../../containers/TermsConditions/TermsConditions";

import "../../App.css";

import "./TermsConditionsPage.css";

const TermsConditionsPage = (props) => {
	useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="terms-conditions-page-container navbar-correction">
			<NavBarCustom />
			<TermsConditions />
			<Footer />
		</div>
	);
};

export default TermsConditionsPage;
